import { dehydrate, QueryClient } from '@tanstack/react-query'
import type { UserListUserActivitiesParams } from '../api'
import { EUserActivityQueryKey } from './user-activity.types'
import userActivityService from './user-activity.service'

export const getListUserActivitiesOptions = (
  params: UserListUserActivitiesParams,
) => {
  return {
    queryKey: [EUserActivityQueryKey.LIST_USER_ACTIVITIES, params],
    queryFn: () => userActivityService.getList(params),
  }
}

export const prefetchListUserActivities = async (
  params: UserListUserActivitiesParams,
) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(getListUserActivitiesOptions(params))
  return dehydrate(queryClient)
}
